import React from 'react';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';

export const SelectionCell = ({ row, selected, onToggle, borderColor, ariaLabel, disableDirectories, ...restProps }) => {
  // Check if this is a directory/folder that should be disabled
  const isDirectory = disableDirectories && (row?.isDir || row?.isFolder);

  // Default aria-label if not provided
  const rowIdentifier = row?.filePath || row?.name || row?.id || '';
  const label = ariaLabel || `Select row ${rowIdentifier}`;

  return (
    <TableCell
      align="center"
      sx={{
        ...(borderColor && {
          borderLeft: `3px solid ${borderColor}`,
          paddingLeft: '5px !important'
        }),
        ...(!borderColor && {
          paddingLeft: '8px !important'
        })
      }}
      {...restProps}
    >
      <Checkbox
        sx={{
          padding: '12px'
        }}
        checked={!!selected}
        onChange={onToggle}
        disabled={isDirectory}
        inputProps={{
          'aria-label': label
        }}
      />
    </TableCell>
  );
};

export const SelectAllHeaderCell = ({ disabled, allSelected, someSelected, onToggle, selectAllAriaLabel, ...restProps }) => {
  const label = selectAllAriaLabel || 'Select all rows';

  return (
    <TableCell
      align="center"
      aria-label="Selection"
      sx={{
        padding: 0,
        paddingLeft: '8px'
      }}
      {...restProps}
    >
      <Checkbox
        checked={allSelected}
        indeterminate={someSelected}
        disabled={disabled}
        onChange={() => onToggle()}
        inputProps={{
          'aria-label': label
        }}
      />
    </TableCell>
  );
};
